export default function About() {
  return (
    <section className="section">
      <div className="container">
        <h1 className="page-title">About Us</h1>

        <p className="page-text">
          <strong>BioLogist  Private Limited</strong> specializes in
          cutting-edge biotechnology solutions, including logistics for
          biological materials, advanced research tools, and innovative
          technology integrations.
        </p>

        <p className="page-text">
          Founded in 2023, we serve clients globally with a strong focus on
          <strong> safety, efficiency, and sustainability</strong>.
        </p>
      </div>
    </section>
  );
}
